module.exports = __webpack_public_path__ + "img/20.2.TN.c953d3d2.png";